import { useHistory } from "react-router-dom";

import { authenticatedRouting } from "@/modules/router/routings/authenticatedRouting";

type HandleTutorialNavigationParams = {
  nextStep: number | null;
  tutorialId: string;
  testAvailable: boolean;
};

export function useHandleTutorialsNavigation() {
  const history = useHistory();
  return ({
    nextStep,
    tutorialId,
    testAvailable,
  }: HandleTutorialNavigationParams) => {
    if (nextStep) {
      history.push(
        authenticatedRouting.buildUrl("tutorialDetails", {
          params: {
            id: tutorialId,
            step: `${nextStep}`,
          },
        })
      );
    } else {
      if (testAvailable) {
        history.push(
          authenticatedRouting.buildUrl("tutorialTest", {
            params: {
              id: tutorialId,
            },
          })
        );
      } else {
        history.push(authenticatedRouting.buildUrl("tutorials"));
      }
    }
  };
}
